export const tossColor = {
  800: "#45505F",
  700: "#3182F6",
  300: "#E8F3FF",
};
